// extracted by mini-css-extract-plugin
export default {"alignCenter":"VerifyButton_alignCenter__vSfTG"};